export default __webpack_public_path__ + "static/media/DissertacaoMartaMacedoBrietzke.cdc55680.pdf";